// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1zge5","noInteraction":"EventWrapper_noInteraction__3o2uU"};